import { createFileRoute } from '@tanstack/react-router';
import { ConfigurationEditPage } from '../pages/configuration/configuration-edit-page';

export const Route = createFileRoute('/configuration/$key/edit')({
  component: function ConfigurationEditRoute() {
    const { key } = Route.useParams();
    return <ConfigurationEditPage configurationKey={key} />;
  },
});
